import { capturePropertyCheckFromCurrentUrl } from "./propertyCheckNavigation";
import { captureGuestAccessFromCurrentUrl } from "./guestAccessUrl";
import { guardUnavailableSessionStorage } from "./unavailableSessionStorage";

// This module is the FIRST import in main.tsx. Calling these in main's body
// is too late: static imports already evaluate the router and its dependencies.
guardUnavailableSessionStorage();
capturePropertyCheckFromCurrentUrl();
captureGuestAccessFromCurrentUrl();
